module.exports = __webpack_public_path__ + "img/sort_normal.3ed22508.svg";